export var INTERNAL_PROPS_MARK = 'RC_SELECT_INTERNAL_PROPS_MARK';


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-select/es/interface/generator.js
// module id = 692
// module chunks = 0